// This allows us to load Angular components on legacy server-side pages.
import type { OnInit } from '@angular/core';
import {
  Compiler,
  Component,
  HostBinding,
  Injector,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { components } from './components';

@Component({
  selector: 'webapp-compat',
  template: `
    <ng-container #entryPoint></ng-container>
    <router-outlet></router-outlet>
  `,
})
export class CompatComponent implements OnInit {
  @ViewChild('entryPoint', { read: ViewContainerRef, static: true })
  entryPoint: ViewContainerRef;

  @HostBinding('class')
  readonly class = 'WebappCompatWrapper';

  constructor(
    // eslint-disable-next-line deprecation/deprecation
    private compiler: Compiler,
    @SkipSelf() private injector: Injector,
  ) {}

  ngOnInit() {
    Promise.all(
      components
        // Only bootstrap the components on the page
        .filter(({ selector }) => document.getElementsByTagName(selector)[0])
        // Load the module and component
        .map(async componentItem => ({
          componentIndex: componentItem.index,
          module: await componentItem.loadModule(),
          componentType: await componentItem.loadComponent(),
        })),
    ).then(loadedComponents => {
      Promise.all(
        loadedComponents.map(
          async ({ componentIndex, module, componentType }) => ({
            componentIndex,
            compiledModule: await this.compiler.compileModuleAsync(module),
            componentType,
          }),
        ),
      ).then(loadedComponentsWithCompiledModules =>
        loadedComponentsWithCompiledModules.forEach(
          ({ componentIndex, compiledModule, componentType }) => {
            // Resolve component within the module scope
            const componentFactory = compiledModule
              .create(this.injector)
              // eslint-disable-next-line deprecation/deprecation
              .componentFactoryResolver.resolveComponentFactory(componentType);

            // Instantiate component in the ng-container
            // eslint-disable-next-line deprecation/deprecation
            this.entryPoint.createComponent(componentFactory, componentIndex);
          },
        ),
      );
    });
  }
}
